import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React, { ReactNode, useState } from 'react';

import { CustomTableEventModel } from '@/components/table/model/CutomTableEvent.model.ts';
import { customTableEventDispatcher } from '@/components/table/util/customTableEventDispatcher.util.ts';

interface Props {
  cancelButtonLabel: string;
  confirmButtonLabel: string;
  content: ReactNode;
  icon?: React.ReactNode;
  name?: ReactNode;
  onCancel: () => void;
  onConfirm: () => Promise<void> | void;
  title: string;
}

export const CommonDialog: React.FC<Props> = props => {
  const { cancelButtonLabel, confirmButtonLabel, content, icon, name, onCancel, onConfirm, title } =
    props;
  const [isConfirming, setIsConfirming] = useState(false);

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      await onConfirm();
      customTableEventDispatcher(CustomTableEventModel.REFRESH);
      onCancel();
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <Dialog onClose={onCancel} open={true}>
      <DialogTitle>
        <Typography variant={'f20Regular'}>{title}</Typography>
      </DialogTitle>
      <DialogContent sx={{ minHeight: '150px' }}>
        <Stack
          direction="row"
          spacing={4}
          sx={{ alignItems: 'center', justifyContent: 'flex-start' }}
        >
          {icon}
          <Box sx={{ width: '100%' }}>
            <Typography variant={'f14Regular'}>
              {content}{' '}
              <Box sx={{ maxHeight: '150px', overflowY: 'auto' }}>
                {name && (
                  <div>
                    <b>{name}</b>
                  </div>
                )}
              </Box>
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={isConfirming} onClick={onCancel} variant="outlined">
          {cancelButtonLabel}
        </Button>
        <Button loading={isConfirming} onClick={handleConfirm}>
          {confirmButtonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
